// pubkey self
import selfHtml from './s34-privkey_link_device_scan.html' with { type: 'text' };

import { mod_loader, PrivKeyLinkScanModule, db_PrivateKeyPair, BASEURL } from "../AppState.js";

import { navbar_active_menu, generate_qr, postData, update_username } from '../utils.js';

import { encrypt_gpg, get_pub_key, generateSecureString, gpg_import_keypair } from "../crypt_helper.js"

var root

export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root

    const my_pubkey = await get_pub_key();

    if (args.link_device.PrivateKeyPair.publicKey == my_pubkey?.myKeyPairPublicKey) {
        $e(root).getEl("public_key_myself").classList.remove("d-none");
        return;
    }
        
    if (my_pubkey) {
        console.log("Priorty key not found");
        $e(root).getEl("public_key_already_exists").classList.remove("d-none");
    } else {
        $e(root).getEl("public_key_import").classList.remove("d-none");
    }


    $e(root).getEl("public_key_override").addEventListener('click', async () => {
        $e(root).getEl("public_key_import").classList.remove("d-none");
        $e(root).getEl("public_key_already_exists").classList.add("d-none");
    });

    $e(root).getEl("public_key_import").addEventListener('click', async () => {
        try {
            await gpg_import_keypair(args.link_device.PrivateKeyPair.privateKey,
                args.link_device.PrivateKeyPair.publicKey,
                args.link_device.PrivateKeyPair.passphrase);
            update_username();
            $e(root).getEl("public_key_success").classList.add("d-none");
            $e(root).getEl("public_key_success").classList.remove("d-none");
            $e(root).getEl("btn_pubk_key_import").disabled = true;
        } catch (err) {
            console.log(err);
            show_modal("Invalid key", err.message);
        }

    });


}
